<template>
    <div class="mx-2 mb-2">
        <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{$t('Showing')}} {{vsEntries.from}} {{$t('to')}} {{vsEntries.to}} {{$t('of')}} {{vsEntries.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <BPagination v-model="vsCurrent" :total-rows="vsTotal" :per-page="vsPerPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                    <template #prev-text>
                        <FeatherIcon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                        <FeatherIcon icon="ChevronRightIcon" size="18" />
                    </template>
                </BPagination>
            </BCol>
        </BRow>
    </div>
</template>
<script>
import { BCol, BPagination, BRow } from 'bootstrap-vue';

export default {
    components: { BRow, BCol, BPagination },
    props: ['vsEntries', 'vsCurrent', 'vsTotal', 'vsPerPage'],
}
</script>